import 'normalize.css';
import './style/base.scss';
import './style/index.scss';
import './style/mobile-index.scss'
import $ from "jquery";

import { throttle, isMobile } from './script/util';
import { qrcodeGen } from './script';

function getDomById(id) {
  return document.getElementById(id)
}

function getViewport() {
  return {
    width: window.innerWidth,
    height: window.innerHeight
  }
}

function setMinHeight() {
  document.querySelector('.body-container').style.minHeight = getViewport().height - 274 - 54 - 40 + 'px';
}

var canvasIOS = getDomById('canvas_ios');
var canvasAndroid = getDomById('canvas_android');
var canvasInstallIOS = getDomById('canvas_install_ios');
var canvasInstallAndroid = getDomById('canvas_install_android');
var canvasIOSFooter = getDomById('canvas_ios_footer');
var canvasAndroidFooter = getDomById('canvas_android_footer');
var canvasInstallIOSFooter = getDomById('canvas_install_ios_footer');
var canvasInstallAndroidFooter = getDomById('canvas_install_android_footer');

var params = { c: getQueryString()['c'] };
const prefix = location.protocol + "//" + location.host;

const iOSLink = concatURL(prefix + '/app/ios/latest', params)
const androidLink = concatURL(prefix + '/app/android/latest.apk', params)

getDomById('canvas_ios_link').href = iOSLink
getDomById('canvas_android_link').href = androidLink

function qrcode() {
  qrcodeGen(canvasIOS, iOSLink, 145);
  qrcodeGen(canvasAndroid, androidLink, 145);
  qrcodeGen(canvasInstallIOS, iOSLink, 120);
  qrcodeGen(canvasInstallAndroid, androidLink, 120);
  qrcodeGen(canvasIOSFooter, iOSLink, 109);
  qrcodeGen(canvasAndroidFooter, androidLink, 109);
  qrcodeGen(canvasInstallIOSFooter, iOSLink, 92);
  qrcodeGen(canvasInstallAndroidFooter, androidLink, 92);
}

setMinHeight();
qrcode();
installPageHandle();

function handleResize() {
  qrcode();
  setMinHeight();
  installPageHandle();
}

window.onresize = throttle(handleResize, 300);

const sidebar = getDomById('sidebar');
const path = location.pathname;
const pathReg = /.*\/([^/.]*)(\.html)?/;
if (sidebar) {
  if (path.match(pathReg)) {
    getDomById('nav-' + path.match(pathReg)[1]).className += ' side-active';
  }
}

function installPageHandle() {
  if (isMobile && location.pathname.indexOf('install') !== -1) {
    setInstallHeaderHight();
  }
}


function setInstallHeaderHight() {
  let header = document.querySelector('.header-mobile');
  if (!header) return;
  header.style.height = parseInt(getViewport().width * (208 / 375), 10) + 'px';
}

function getQueryString(url) {
  var result = {}, queryString = (url && url.indexOf("?")!=-1 && url.split("?")[1]) || location.search.substring(1),
      re = /([^&=]+)=([^&]*)/g, m;
  while (m = re.exec(queryString)) {
      result[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
  }
  return result;
}


function concatURL(url, params){
  if(params instanceof Object){
      var temp = [];
      for(var key in params){
          temp.push(key + '=' + encodeURIComponent(params[key] || ''))
      }
      params = temp.join('&');
  }
  url += url.indexOf('?') !== -1 ? '&' : '?';
  return url + params;
}


if (isMobile) {
  let iosBtn = document.querySelector('#ios-latest');
  if (iosBtn) {
    iosBtn.addEventListener('click', function(e) {
      e.preventDefault();
      window.open(iosBtn.href);
      location.href = '/install.html';
    });
  }
  var wwwDomain = window.location.origin;
  var ua = navigator.userAgent,
  weixin = ua.match(/MicroMessenger/ig),
  QQ = ua.match(/QQ\//),
  isWeibo = ua.match(/WeiBo/i);
  $(function () {
    // $('.spread-wrap').on('click', '.sp-img2', function () {
    //   if (isWeibo) {
    //     alert('请在浏览器中打开')
    //   } else {
    //     down();
    //   }
    // });
    $('#to_download_btn').on('click', function () {
      if (isWeibo) {
        alert('请在浏览器中打开')
      } else {
        down();
      }
    });
    $(window).on('scroll', function () {
      if ($(window).scrollTop() > 0) {
        $('.img-bottom').show();
      } else {
        $('.img-bottom').hide();
      }
    })
    // $('body').on('click', '.back', function () {
    //     $('.warp').show();
    //     $('.install_container').hide();
    // })
  });
}

function down() {
  var params = { c: getQueryString()['c'] };
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    window.location.href = concatURL(wwwDomain + '/app/ios/latest', params); //苹果下载地址
  } else if (/(Android)/i.test(navigator.userAgent)) {
    window.location.href = concatURL(wwwDomain + '/app/android/latest.apk', params); //安卓下载地址
  }
}
